module.exports = __webpack_public_path__ + "img/4-insurance-zone-chat.0a52c446.jpg";